import React from 'react'
function Button(props) {
    const buttonClass = () =>{
        switch (props.btnStyle){
            case "secondary":
            return "bg-secondary hover:bg-secondary-dark border-secondary text-white justify-center"
            case "secondary-outline":
            return "bg-transparent hover:bg-secondary-light border-secondary text-secondary justify-center"
            case "primary-outline":
            return "bg-transparent hover:bg-primary-light border-primary text-primary justify-center"
            default:
            return "bg-primary hover:bg-primary-dark border-primary text-white justify-center"
        }
    }
    return (
        <button type={props.type} onClick={props.onClick} disabled={props.isDisabled}
            className={`${buttonClass()} ${props.disabled || props.processing ? "opacity-40 pointer-events-none" : "opacity-100"} font-semibold  text-base py-1.5 px-8 rounded-full inline-block border-2  active:border-3 disabled:opacity-50 focus:outline-none ${props.extraClasses}`}>
          {props.processing && <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>}
        {props.text}
        </button>
    )
}

export default Button
